export default __webpack_public_path__ + "static/media/Z.deceed90.svg";